import cn from 'classnames';
import { useCallback } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Logo } from '@sravni/react-design-system/lib/Logo';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useAuthLoginLink, useIsMobile } from '@sravni/react-utils';

import { sendAnalytics } from '../../../utils/analitycs';
import { smoothScrollTo } from '../../../utils/smoothScroll';

import styles from './styles.module.scss';

export const Header = () => {
  const isMobile = useIsMobile();
  const loginLinkProps = useAuthLoginLink({ loginType: 'email' });

  const onLoginClick = useCallback(() => {
    sendAnalytics({
      eventAction: 'Лендинг',
      eventLabel: 'Шапка|Войти',
    });
  }, []);

  const onRegisterClick = useCallback(() => {
    sendAnalytics({
      eventAction: 'Лендинг',
      eventLabel: 'Шапка|Зарегистрироваться',
    });
  }, []);

  return (
    <Space justify="space-between" align="center" className={cn(styles.header, isMobile && styles.mobile)} size={60}>
      <Logo />
      {!isMobile && (
        <Space size={32} className="h-ml-4">
          <Link color="dark" strong href="https://www.sravni.ru/">
            О нас
          </Link>
          <Link color="dark" strong onClick={smoothScrollTo} href="#advantages">
            Веб мастерам
          </Link>
          <Link color="dark" strong onClick={smoothScrollTo} href="#offers">
            Офферы
          </Link>
        </Space>
      )}

      <Space size={20} justify="end">
        <Link {...loginLinkProps} onClick={onLoginClick}>
          <Button size={36} variant={isMobile ? 'primary' : 'outlined'}>
            Войти
          </Button>
        </Link>
        {!isMobile && (
          <Link href="/signup" onClick={onRegisterClick}>
            <Button size={36} variant="primary">
              Зарегистрироваться
            </Button>
          </Link>
        )}
      </Space>
    </Space>
  );
};
